/**
 * Stops a developer's browser from writing to production MDM state.
 *
 * Dev and production share ONE Android Management enterprise (and one managed-Play publisher), while the
 * settings behind them live in each environment's own Couchbase. A Backoffice on `localhost` therefore
 * lists the real fleet, the real policies and the real APKs, and a click there reaches a till in a
 * restaurant. The pages that write to that shared state refuse to do so from localhost.
 *
 * NOT a security boundary: the backend cannot tell a developer's browser from the real console, so anyone
 * determined can bypass it. It exists to stop the accident — re-policying the fleet, publishing an APK or
 * wiping a live till because the tab looked like the dev one.
 *
 * KEEP THIS, permanently. A separate dev enterprise later removes the usual CAUSE (see
 * CAGISTA/DeviceManagement_MDM_Strategy.md), not the value of refusing to write production config from a
 * dev tab — environments still get crossed, and a dev Backoffice can still be pointed at production.
 * Do not delete it as obsolete.
 */

/** True when Backoffice is served from a developer's machine rather than the real console. */
export function isLocalDev() {
    const h = window.location.hostname;
    return h === "localhost" || h === "127.0.0.1" || h === "[::1]" || h === "::1";
}

/**
 * Refuses a write on a page whose target is the shared production enterprise, explaining why.
 *
 *   if (await refuseIfLocalDev(this.$refs.confirmDialog, "Policyer kan leses herfra, men ikke …")) return;
 *
 * @param dialog  a ConfirmDialogue ref
 * @param consequence  one sentence: what this page's writes would do to production
 * @returns true when the caller must abort
 */
export async function refuseIfLocalDev(dialog, consequence) {
    if (!isLocalDev()) return false;
    if (dialog) {
        await dialog.show({
            title: "Skrivebeskyttet miljø",
            message:
                "Backoffice kjører fra <code>localhost</code> mot samme AMAPI-enterprise som produksjon." +
                "<br><br>" + consequence +
                "<br><br>Bruk produksjons-Backoffice hvis endringen er tilsiktet.",
            okButton: "Lukk"
        });
    }
    return true;
}
